export const ACTIVITIES_GET_BY_COACHEE = 'ACTIVITIES_GET_BY_COACHEE';
export const ACTIVITIES_GET_BY_ID = 'ACTIVITIES_GET_BY_ID';
export const ACTIVITIES_POST = 'ACTIVITIES_POST';
export const ACTIVITIES_UPDATE_BY_ID = 'ACTIVITIES_UPDATE_BY_ID';
export const ACTIVITIES_DELETE = 'ACTIVITIES_DELETE';
export const ACTIVITIES_LOADING = 'ACTIVITIES_LOADING';
export const ACTIVITIES_ERROR = 'ACTIVITIES_ERROR';
